/**
 * @generated SignedSource<<fc02b6359a388c701e91ba76cb7e3990>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActionItemIntegrationSyncStatus = "CREATING_EXTERNALLY" | "DONE_SYNCING_EXTERNALLY" | "FAILED_TO_SYNC_EXTERNALLY" | "SENDING_UPDATE_EXTERNALLY";
export type IntegrationProvider = "ASANA" | "CLICKUP" | "HUBSPOT_TASK" | "JIRA" | "LINEAR" | "MICROSOFT_TODO" | "MONDAY" | "TRELLO";
export type NoteBlockStatus = "done" | "not_done" | "wont_do";
export type NoteBlockUserCategory = "later" | "today" | "upcoming";
export type NoteStreamType = "goalset" | "meeting" | "oneonone" | "personal";
export type NoteType = "private" | "stream";
export type StatusCondition = "ALL" | "SINGLE";
export type CreateTodoInput = {
  afterId?: string | null;
  assigneeId?: string | null;
  assigneeIds?: ReadonlyArray<string> | null;
  beforeId?: string | null;
  category?: NoteBlockUserCategory | null;
  clientMutationId?: string | null;
  content: any;
  dueDate?: string | null;
  groupId?: string | null;
  statusCondition?: StatusCondition | null;
};
export type ActionItemCreateMutation$variables = {
  input: CreateTodoInput;
};
export type ActionItemCreateMutation$data = {
  readonly createTodo: {
    readonly block: {
      readonly actionItemIntegrationLink: {
        readonly actionItem: {
          readonly id: string;
          readonly key: string;
          readonly originalBlockId: string | null;
        };
        readonly createdAt: string | null;
        readonly id: string;
        readonly integrationData: {
          readonly __typename: "ClickupActionItemIntegrationSpecificDataNode";
          readonly externalTaskId: string;
          readonly listName: string;
          readonly status: string;
          readonly statusColor: string;
        } | {
          readonly __typename: "HubspotTaskActionItemIntegrationSpecificDataNode";
          readonly externalTaskId: string;
          readonly hubspotUrl: string;
        } | {
          readonly __typename: "LinearActionItemIntegrationSpecificDataNode";
          readonly externalIdentifier: string | null;
          readonly linearUser: {
            readonly id: string;
            readonly isConnected: boolean;
            readonly organizationUrlKey: string;
          };
          readonly statusColor: string;
          readonly statusName: string;
          readonly teamName: string;
        } | {
          readonly __typename: "MicrosoftTodoActionItemIntegrationSpecificDataNode";
          readonly externalListId: string;
          readonly externalListName: string;
          readonly externalTaskId: string;
          readonly microsoftTodoUser: {
            readonly isConnected: boolean;
          };
          readonly status: string;
        } | {
          readonly __typename: "MondayActionItemIntegrationSpecificDataNode";
          readonly externalBoardId: string;
          readonly externalBoardName: string;
          readonly externalGroupName: string;
          readonly externalTaskId: string;
          readonly mondayUser: {
            readonly accountSlug: string;
          };
          readonly status: string;
        } | {
          readonly __typename: "TrelloActionItemIntegrationSpecificDataNode";
          readonly boardName: string;
          readonly externalCardId: string | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        };
        readonly integrationProvider: IntegrationProvider;
        readonly lastSyncedError: string | null;
        readonly syncStatus: ActionItemIntegrationSyncStatus;
        readonly updatedAt: string | null;
      } | null;
      readonly aiGenerated: boolean;
      readonly asanablocklink: {
        readonly externalId: string | null;
        readonly id: string;
        readonly project: {
          readonly externalId: string | null;
          readonly id: string;
          readonly name: string;
        };
      } | null;
      readonly assigneeChangedAt: string;
      readonly assigneeId: string | null;
      readonly assignments: ReadonlyArray<{
        readonly assignee: {
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly isActive: boolean;
          readonly isExternal: boolean;
          readonly isGuest: boolean;
        };
        readonly status: NoteBlockStatus | null;
      }> | null;
      readonly blockId: string;
      readonly blockKey: string;
      readonly completedBy: {
        readonly fullName: string;
        readonly id: string;
      } | null;
      readonly createdAt: string | null;
      readonly creator: {
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly isExternal: boolean;
        readonly isGuest: boolean;
      } | null;
      readonly creatorId: string | null;
      readonly done: boolean;
      readonly dueDate: string | null;
      readonly entityRanges: any;
      readonly hasAccessToNote: boolean;
      readonly hasLink: boolean | null;
      readonly hasOriginalBlock: boolean;
      readonly id: string;
      readonly key: string;
      readonly note: {
        readonly entityMap: any;
        readonly id: string;
        readonly isLocked: boolean;
        readonly noteuserSet: ReadonlyArray<{
          readonly id: string;
          readonly user: {
            readonly email: string;
            readonly firstName: string;
            readonly fullName: string;
            readonly id: string;
            readonly image: string;
            readonly internalAttributes: {
              readonly invitable: boolean;
            } | null;
            readonly isExternal: boolean;
          };
        }>;
        readonly stream: {
          readonly __typename: string;
          readonly displayName: string;
          readonly id: string;
          readonly isExternal: boolean;
          readonly isTodoStream: boolean;
          readonly type?: NoteStreamType;
          readonly url: string | null;
        };
        readonly type?: NoteType | null;
        readonly url?: string | null;
      };
      readonly noteId: string;
      readonly originalBlock: {
        readonly id: string;
        readonly noteId: string;
      } | null;
      readonly recordingId: string | null;
      readonly recordingOffset: number | null;
      readonly statusCondition: StatusCondition | null;
      readonly text: string;
      readonly type: string;
      readonly updatedAt: string | null;
      readonly userOrder: string;
      readonly userOrderWithinGroup: string | null;
      readonly wontDo: boolean;
    } | null;
  } | null;
};
export type ActionItemCreateMutation = {
  response: ActionItemCreateMutation$data;
  variables: ActionItemCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wontDo",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aiGenerated",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recordingId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recordingOffset",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasOriginalBlock",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userOrder",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userOrderWithinGroup",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityRanges",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assigneeChangedAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creatorId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assigneeId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noteId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccessToNote",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLink",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusCondition",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "completedBy",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v25/*: any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteBlock",
  "kind": "LinkedField",
  "name": "originalBlock",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v21/*: any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityMap",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "stream",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTodoStream",
      "storageKey": null
    },
    (v31/*: any*/),
    (v32/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v4/*: any*/)
      ],
      "type": "NoteStream",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invitable",
  "storageKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v32/*: any*/)
  ],
  "type": "Note",
  "abstractKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v25/*: any*/),
    (v36/*: any*/),
    (v40/*: any*/),
    (v31/*: any*/),
    (v34/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v25/*: any*/),
    (v36/*: any*/),
    (v40/*: any*/),
    (v31/*: any*/)
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteBlock",
  "kind": "LinkedField",
  "name": "actionItem",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalBlockId",
      "storageKey": null
    },
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "syncStatus",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSyncedError",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationProvider",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalTaskId",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "listName",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusColor",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalCardId",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boardName",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalGroupName",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalBoardId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalBoardName",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountSlug",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalIdentifier",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusName",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "LinearUserNode",
  "kind": "LinkedField",
  "name": "linearUser",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v59/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationUrlKey",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalListId",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalListName",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hubspotUrl",
  "storageKey": null
},
v64 = {
  "alias": "blockId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v65 = {
  "alias": "blockKey",
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalId",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "concreteType": "AsanaBlockLinkNode",
  "kind": "LinkedField",
  "name": "asanablocklink",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AsanaProjectNode",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        (v66/*: any*/)
      ],
      "storageKey": null
    },
    (v66/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateTodoPayload",
        "kind": "LinkedField",
        "name": "createTodo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteBlock",
            "kind": "LinkedField",
            "name": "block",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteUser",
                    "kind": "LinkedField",
                    "name": "noteuserSet",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v25/*: any*/),
                          (v36/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteBlockAssignment",
                "kind": "LinkedField",
                "name": "assignments",
                "plural": true,
                "selections": [
                  (v39/*: any*/),
                  (v41/*: any*/)
                ],
                "storageKey": null
              },
              (v42/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ActionItemIntegrationLinkNode",
                "kind": "LinkedField",
                "name": "actionItemIntegrationLink",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v43/*: any*/),
                  (v14/*: any*/),
                  (v12/*: any*/),
                  (v44/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integrationData",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v39/*: any*/),
                          (v49/*: any*/)
                        ],
                        "type": "ClickupActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/)
                        ],
                        "type": "TrelloActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          (v47/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MondayUserNode",
                            "kind": "LinkedField",
                            "name": "mondayUser",
                            "plural": false,
                            "selections": [
                              (v55/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MondayActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          (v56/*: any*/),
                          (v57/*: any*/),
                          (v58/*: any*/),
                          (v49/*: any*/),
                          (v60/*: any*/)
                        ],
                        "type": "LinearActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          (v47/*: any*/),
                          (v61/*: any*/),
                          (v62/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MicrosoftTodoUserNode",
                            "kind": "LinkedField",
                            "name": "microsoftTodoUser",
                            "plural": false,
                            "selections": [
                              (v59/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MicrosoftTodoActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v30/*: any*/),
                          (v47/*: any*/),
                          (v63/*: any*/)
                        ],
                        "type": "HubspotTaskActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v64/*: any*/),
              (v65/*: any*/),
              (v67/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ActionItemCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateTodoPayload",
        "kind": "LinkedField",
        "name": "createTodo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteBlock",
            "kind": "LinkedField",
            "name": "block",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v2/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v33/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteUser",
                    "kind": "LinkedField",
                    "name": "noteuserSet",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v34/*: any*/),
                          (v35/*: any*/),
                          (v25/*: any*/),
                          (v36/*: any*/),
                          (v31/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInternalAttributes",
                            "kind": "LinkedField",
                            "name": "internalAttributes",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v38/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteBlockAssignment",
                "kind": "LinkedField",
                "name": "assignments",
                "plural": true,
                "selections": [
                  (v39/*: any*/),
                  (v41/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v42/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ActionItemIntegrationLinkNode",
                "kind": "LinkedField",
                "name": "actionItemIntegrationLink",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v43/*: any*/),
                  (v14/*: any*/),
                  (v12/*: any*/),
                  (v44/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "integrationData",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v47/*: any*/),
                          (v48/*: any*/),
                          (v39/*: any*/),
                          (v49/*: any*/)
                        ],
                        "type": "ClickupActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v50/*: any*/),
                          (v51/*: any*/)
                        ],
                        "type": "TrelloActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v47/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MondayUserNode",
                            "kind": "LinkedField",
                            "name": "mondayUser",
                            "plural": false,
                            "selections": [
                              (v55/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MondayActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v56/*: any*/),
                          (v57/*: any*/),
                          (v58/*: any*/),
                          (v49/*: any*/),
                          (v60/*: any*/)
                        ],
                        "type": "LinearActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v47/*: any*/),
                          (v61/*: any*/),
                          (v62/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MicrosoftTodoUserNode",
                            "kind": "LinkedField",
                            "name": "microsoftTodoUser",
                            "plural": false,
                            "selections": [
                              (v59/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "MicrosoftTodoActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v47/*: any*/),
                          (v63/*: any*/)
                        ],
                        "type": "HubspotTaskActionItemIntegrationSpecificDataNode",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v64/*: any*/),
              (v65/*: any*/),
              (v67/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "130bd213caa982508cdb9a2102dd2a6f",
    "id": null,
    "metadata": {},
    "name": "ActionItemCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemCreateMutation(\n  $input: CreateTodoInput!\n) {\n  createTodo(input: $input) {\n    block {\n      id\n      key\n      type\n      text\n      done\n      wontDo\n      aiGenerated\n      recordingId\n      recordingOffset\n      hasOriginalBlock\n      updatedAt\n      dueDate\n      createdAt\n      userOrder\n      userOrderWithinGroup\n      entityRanges\n      assigneeChangedAt\n      creatorId\n      assigneeId\n      noteId\n      hasAccessToNote\n      hasLink\n      statusCondition\n      completedBy {\n        id\n        fullName\n      }\n      originalBlock {\n        id\n        noteId\n      }\n      note {\n        __typename\n        id\n        isLocked\n        entityMap\n        stream {\n          __typename\n          id\n          displayName\n          isTodoStream\n          isExternal\n          url\n          ... on NoteStream {\n            type\n          }\n        }\n        noteuserSet {\n          id\n          user {\n            id\n            email\n            firstName\n            fullName\n            image\n            isExternal\n            internalAttributes {\n              invitable\n              id\n            }\n          }\n        }\n        ... on Note {\n          type\n          url\n        }\n      }\n      assignments {\n        status\n        assignee {\n          id\n          fullName\n          image\n          isGuest\n          isExternal\n          email\n          isActive\n        }\n        id\n      }\n      creator {\n        id\n        fullName\n        image\n        isGuest\n        isExternal\n      }\n      actionItemIntegrationLink {\n        id\n        actionItem {\n          originalBlockId\n          id\n          key\n        }\n        createdAt\n        updatedAt\n        syncStatus\n        lastSyncedError\n        integrationProvider\n        integrationData {\n          __typename\n          ... on ClickupActionItemIntegrationSpecificDataNode {\n            __typename\n            externalTaskId\n            listName\n            status\n            statusColor\n          }\n          ... on TrelloActionItemIntegrationSpecificDataNode {\n            __typename\n            externalCardId\n            boardName\n          }\n          ... on MondayActionItemIntegrationSpecificDataNode {\n            __typename\n            externalTaskId\n            externalGroupName\n            externalBoardId\n            externalBoardName\n            status\n            mondayUser {\n              accountSlug\n              id\n            }\n          }\n          ... on LinearActionItemIntegrationSpecificDataNode {\n            __typename\n            externalIdentifier\n            teamName\n            statusName\n            statusColor\n            linearUser {\n              id\n              isConnected\n              organizationUrlKey\n            }\n          }\n          ... on MicrosoftTodoActionItemIntegrationSpecificDataNode {\n            __typename\n            externalTaskId\n            externalListId\n            externalListName\n            status\n            microsoftTodoUser {\n              isConnected\n              id\n            }\n          }\n          ... on HubspotTaskActionItemIntegrationSpecificDataNode {\n            __typename\n            externalTaskId\n            hubspotUrl\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n      blockId: id\n      blockKey: key\n      asanablocklink {\n        id\n        project {\n          id\n          name\n          externalId\n        }\n        externalId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f14cfb41c0aa7cae369576c5d84d6250";

export default node;
